export default __webpack_public_path__ + "assets/img/cut_out.ca88a2a1.png";